import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = {
  class: "dropdown action-opt",
  style: {"right":"-1px"}
}
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_6 = { class: "default-table-area style-two py-11" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle" }
const _hoisted_9 = { class: "text-body" }
const _hoisted_10 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "fw-medium text-secondary fs-13" }
const _hoisted_13 = { class: "fw-normal fs-12 text-body" }
const _hoisted_14 = { class: "text-body text-end fs-13" }
const _hoisted_15 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_16 = { class: "fs-13" }
const _hoisted_17 = { "aria-label": "Page navigation example" }
const _hoisted_18 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_19 = { class: "page-item" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "page-item"
}
const _hoisted_22 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 2,
  class: "page-item disabled"
}
const _hoisted_25 = {
  key: 3,
  class: "page-item"
}
const _hoisted_26 = { class: "page-item" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "mb-0" }, "Live Price Tracker", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "ri-more-fill fs-26 text-body lh-1" })
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTimeRange('24h')))
              }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTimeRange('7d')))
              }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTimeRange('30d')))
              }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTimeRange('1y')))
              }, " This Year ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedCoins, (coin) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: coin.id
                }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: coin.image,
                        style: {"max-width":"22px"},
                        alt: coin.name
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(coin.name) + " ", 1),
                        _createElementVNode("span", _hoisted_13, "(" + _toDisplayString(coin.symbol.toUpperCase()) + ")", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, " $" + _toDisplayString(_ctx.formatPrice(coin.current_price)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["text-end", _ctx.getPriceChangeClass(coin.price_change_percentage_24h)])
                  }, _toDisplayString(_ctx.formatPercentage(coin.price_change_percentage_24h)), 3)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, " Showing " + _toDisplayString(_ctx.showingRange) + " of " + _toDisplayString(_ctx.coins.length) + " results ", 1),
          _createElementVNode("nav", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", _hoisted_19, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_20)
              ]),
              (_ctx.currentPage > 4)
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage(1)))
                    }, "1")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentPage > 4)
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_23)
                ]))
              }), 128)),
              (_ctx.currentPage < _ctx.totalPages - 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_24, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.currentPage < _ctx.totalPages - 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPage(_ctx.totalPages)))
                    }, _toDisplayString(_ctx.totalPages), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_26, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_27)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}